import { render, staticRenderFns } from "./MyContact.vue?vue&type=template&id=2bd56adb&scoped=true"
import script from "./MyContact.vue?vue&type=script&lang=js"
export * from "./MyContact.vue?vue&type=script&lang=js"
import style0 from "./MyContact.vue?vue&type=style&index=0&id=2bd56adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd56adb",
  null
  
)

export default component.exports